



/* eslint-disable no-sequences */
/* eslint-disable no-unused-vars */
/* eslint-disable no-param-reassign */
/* eslint-disable no-unused-expressions */

import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { defaultReject, defaultState } from "../../../../constants";
import { fetchData } from "../../../../helpers";

// DELETEREFERRALSSECTION
// DELETEREFERRALSSECTION


const DELETEREFERRALSSECTION= createAsyncThunk(
  "deleteReferralSection/deleteReferralSection",
  // eslint-disable-next-line default-param-last
  async (
    // eslint-disable-next-line default-param-last
    payload = {},
    { rejectWithValue }
  ) => {
    try {
      const data = await fetchData(
        payload?.data,
        payload?.method,
        payload?.apiName
      );
      return {
        ...defaultState.List,
        message: data?.data.Message,
        data: data?.data?.data,
      };
    } catch (error) {
      return rejectWithValue({
        ...defaultReject.List,
        message: error.message,
      });
    }
  }
);

// PublishPostSlice
const deleteReferralSectionSlice = createSlice({
  name: "deleteReferralSectionSlice",
  initialState: {
    deleteReferralSection: {
      ...defaultState.List,
      loading: false, 
      error: false, 
    },
  },
  reducers: {
    setInitialStateOfdeleteReferralSection: (state) => {
        state.deleteReferralSection.loading = false
        state.deleteReferralSection.error = false
        state.deleteReferralSection.data = []
        state.deleteReferralSection.message = ''
      }
  },
  extraReducers: (builder) => {
    builder.addCase(DELETEREFERRALSSECTION.fulfilled, (state, action) => {
      state.deleteReferralSection = {
        ...state.deleteReferralSection,
        loading: false,
        error: false,
        ...action.payload,
      };
    });
    builder.addCase(DELETEREFERRALSSECTION.pending, (state, action) => {
      state.deleteReferralSection = {
        ...state.deleteReferralSection,
        loading: true,
        error: false,
        ...action.payload,
      };
    });
    builder.addCase(DELETEREFERRALSSECTION.rejected, (state, action) => {
      state.deleteReferralSection = {
        ...state.deleteReferralSection,
        loading: false,
        error: true,
        ...action.payload,
      };
    });
  },
});

const deleteReferralSectionAction = {
    DELETEREFERRALSSECTION,
};

export { deleteReferralSectionAction };
export default deleteReferralSectionSlice.reducer;
export const {setInitialStateOfdeleteReferralSection} = deleteReferralSectionSlice.actions
